require.register("confirmation/app", function(exports, require, module){
  $0
  
});

